// extracted by mini-css-extract-plugin
module.exports = {"section":"SectionSEO_section__vHopL","withHeadingCircles":"SectionSEO_withHeadingCircles__LjbgP","content":"SectionSEO_content__WsEKX","heading":"SectionSEO_heading__TURhg"};